import * as Sentry from "@sentry/react";

/**
 * Handle Vite preload errors that occur when dynamic imports fail.
 *
 * This typically happens after deployments when users have cached HTML
 * that references old chunk files that no longer exist on the CDN.
 *
 * Common on Safari iOS after deployments.
 *
 * @see https://vite.dev/guide/build#load-error-handling
 */
export function initVitePreloadErrorHandler() {
  window.addEventListener("vite:preloadError", (event) => {
    // Log to Sentry for monitoring (if initialized)
    // Note: This handler initializes in bootstrap.ts before Sentry is initialized
    // in app.tsx, so we need to check if Sentry is ready
    if (Sentry && typeof Sentry.captureException === "function") {
      Sentry.captureException(event.payload, {
        tags: {
          error_type: "vite_preload_error",
        },
        level: "warning",
        contexts: {
          vite: {
            event_type: "preload_error",
            user_agent: navigator.userAgent,
          },
        },
      });
    } else {
      // Fallback: Log to console if Sentry not ready
      console.error(
        "[vite:preloadError] Module import failed (Sentry not initialized):",
        event.payload,
      );
    }

    // Reload the page to fetch fresh HTML and assets
    // This is the officially recommended solution from Vite docs
    // This works regardless of Sentry initialization status
    window.location.reload();
  });
}
